
import service from '@/store/services/settings/zone-service';

const state = {
    list: {},
    zone: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, zone) => {
        state.zone = zone;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(zone => {
                commit('SET_RESOURCE', zone);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(zone => {
                commit('SET_RESOURCE', zone);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((zone) => {
                commit('SET_RESOURCE', zone);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((zone) => {
                commit('SET_RESOURCE', zone);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    zone: state => state.zone,
    dropdown: (state) => {
        return state.list.map(zone => ({
            id: zone.id,
            name:zone.name,
            alias:zone.alias,
            report_name:zone.report_name,
        }));
    }
};

const zones = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default zones;
